/**
 * This interceptor removes propping entities in VPC (if they have been saved with enableProppingInVpc=true).
 * This since the propping system will not know of this propping and will not replace/remove it when continuing
 * planning.
 */
export default class RemoveProppingInterceptor {
    constructor(proppingCatalog) {
        this.proppingCatalog = proppingCatalog;
    }
    beforeDeserialize(json) {
        const data = JSON.parse(json);
        const filteredEntities = data.entities?.filter((e) => !this.proppingCatalog.productDTOs().find(product => product.id === e.ref));
        return JSON.stringify({ ...data, entities: filteredEntities });
    }
    beforeParsingComponents() { }
    beforeBuildingEntities() { }
    afterDeserializeComplete() { }
}
//# sourceMappingURL=RemoveProppingInterceptor.js.map